// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const buzzwole: PokeData = {
  "id": 794,
  "name": "buzzwole",
  "height": 24,
  "weight": 3336,
  "base_experience": 257,
  "types": [
    PokeType.BUG,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "comet-punch",
    "mega-punch",
    "ice-punch",
    "thunder-punch",
    "counter",
    "harden",
    "focus-energy",
    "leech-life",
    "reversal",
    "endure",
    "dynamic-punch",
    "vital-throw",
    "focus-punch",
    "taunt",
    "superpower",
    "bulk-up",
    "hammer-arm",
    "fell-stinger",
    "power-up-punch",
    "lunge"
  ],
  "moves": [
    "ice-punch",
    "thunder-punch",
    "superpower",
    "bulk-up",
    "lunge",
    "karate-chop",
    "bug-bite",
    "pounce",
    "jump-kick",
    "sticky-web",
    "drain-punch",
    "heal-order",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 415,
    "item": null,
    "species": [
      {
        "name": "buzzwole",
        "order": 794,
        "types": [
          PokeType.BUG,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 127,
    "speed": 99,
    "ability_power": 174
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
